var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContextMenu',_vm._b({attrs:{"left":"","buttons":_vm.buttons,"icon":_vm.menuActivatorIcon}},'ContextMenu',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }